











import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class FullScreen extends Vue {
  public isFullScreen: boolean = false

  mounted() {
    document.addEventListener('fullscreenchange', this.setFullScreen)
  }

  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.setFullScreen)
  }

  toggleFullScreen() {
    const el = document.documentElement
    if (!this.isFullScreen && el.requestFullscreen) {
      el.requestFullscreen()
    }

    if (this.isFullScreen && document.exitFullscreen) {
      document.exitFullscreen()
    }
  }

  setFullScreen() {
    this.isFullScreen = document.fullscreenElement !== null
  }
}
